import React from 'react';
import { QFlex, QLink } from '@qualio/ui-components';
import { QeSource } from '../../types';
import { showSourceUrl } from '../../utils/integrationSourceUtils';

type QESourceComponentProps = {
  source: QeSource;
};

export const QESourceComponent: React.FC<QESourceComponentProps> = ({ source }) => {
  if (source.type === 'file-import') {
    return (
      <QFlex alignItems="center" data-cy="events-source-component">
        File import
      </QFlex>
    );
  }

  if (showSourceUrl(source.url)) {
    return (
      <QLink data-cy="events-source-component-external-link" href={source.url} isExternal>
        <QFlex alignItems="center" data-cy="events-source-component">
          {source.name}
        </QFlex>
      </QLink>
    );
  }

  return (
    <QFlex alignItems="center" data-cy="events-source-component">
      {source.name}
    </QFlex>
  );
};
